export const HOME = "/"
